import React from 'react';
import styled from 'styled-components';

import { generateImageFromCDN } from '../helpers';

const Wrapper = styled.div`
  position: relative;

  @media (max-width: 500px) {
    align-items: center;
    justify-content: center;
    display: flex;
  }
`;

const Img = styled.img`
  background: center no-repeat #e8e8e8;
  border: solid ${p => p.size / 20}px #fff;
  border-radius: ${p => p.size}px;
  display: inline-block;
  height: ${p => p.size}px;
  width: ${p => p.size}px;
`;

const StatusIndicator = styled.div`
  background: #6dd400;
  border-radius: 15px;
  height: 15px;
  width: 15px;
  position: absolute;
  bottom: 2px;
  left: 0;
`;

export default function Avatar({
  vendor = {},
  size = 150,
  style = {},
  showStatusIndicator = false,
}) {
  return (
    <Wrapper style={style}>
      <Img
        size={size}
        src={
          vendor.contact_image &&
          vendor.contact_image.original &&
          generateImageFromCDN(vendor.contact_image.original, {
            width: size,
            height: size,
            fit: 'facearea',
          })
        }
      />
      {showStatusIndicator && <StatusIndicator size={size} />}
    </Wrapper>
  );
}
